// CustomLayout.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Navbar, Nav } from 'react-bootstrap'; // Import Bootstrap components

function CustomLayout({ children }) {
    const location = useLocation(); // Get the current location
    const [expanded, setExpanded] = useState(false);

    // Updated color schemes
    const constructionColor = '#4285F4'; // Google's blue
    const constructionBorderColor = '#0F9D58'; // Google's green
    const hotelColor = '#0F9D58'; // Google's green
    const hotelBorderColor = '#4285F4'; // Google's blue

    // Define styles for the container and the navigation bar
    const containerStyle = {
        padding: '5px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #ddd',
    };

    const navBarStyle = {
        backgroundColor: 'transparent',
        borderRadius: '8px',
        margin: '0',
    };

    // Define styles for individual buttons and the active button
    const getButtonStyle = (isHotel) => {
        const baseColor = isHotel ? hotelColor : constructionColor;
        const baseBorderColor = isHotel ? hotelBorderColor : constructionBorderColor;

        return {
            textDecoration: 'none',
            padding: '6px 12px',
            borderRadius: '6px',
            color: '#fff',
            backgroundColor: baseColor,
            fontSize: '1rem',
            fontWeight: 'bold',
            border: `2px solid ${baseBorderColor}`,
            transition: 'background-color 0.3s ease',
            margin: '2px',
        };
    };

    const getActiveButtonStyle = (isHotel) => {
        const baseColor = isHotel ? hotelColor : constructionColor;
        return {
            ...getButtonStyle(isHotel),
            backgroundColor: '#ffffff',
            color: baseColor,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        };
    };

    const handleNavClick = () => {
        // Close the navbar if expanded
        setExpanded(false);
        // Reload the page after a short delay to allow navigation
        setTimeout(() => {
            window.location.reload();
        }, 100);
    };

    return (
        <Container fluid style={{ padding: 0 }}>
            {/* Custom header with a specific size */}
            <div style={containerStyle}>
                {/* Responsive Bootstrap Navbar */}
                <Navbar
                    bg="transparent"
                    expand="lg"
                    style={navBarStyle}
                    expanded={expanded}
                    onToggle={(expanded) => setExpanded(expanded)}
                    className="py-0"
                >
                    <Container fluid className="px-2">
                        <Navbar.Toggle aria-controls="navbar-nav" style={{ border: 'none', color: '#fff' }} />
                        <Navbar.Collapse id="navbar-nav">
                            <Nav className="w-100 justify-content-center">
                                {/* Construction group - Blue */}
                                <div style={{ display: 'flex', marginRight: '20px' }}>
                                    <Nav.Link
                                        as={Link}
                                        to="/construction"
                                        style={location.pathname === '/construction' ? getActiveButtonStyle(false) : getButtonStyle(false)}
                                        onClick={handleNavClick}
                                    >
                                        工地相機上傳
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/constructionsearch"
                                        style={location.pathname === '/constructionsearch' ? getActiveButtonStyle(false) : getButtonStyle(false)}
                                        onClick={handleNavClick}
                                    >
                                        多工地管理者分析看版
                                    </Nav.Link>
                                </div>

                                {/* Hotel group - Green */}
                                <div style={{ display: 'flex', marginLeft: '20px' }}>
                                    <Nav.Link
                                        as={Link}
                                        to="/hotel"
                                        style={location.pathname === '/hotel' ? getActiveButtonStyle(true) : getButtonStyle(true)}
                                        onClick={handleNavClick}
                                    >
                                        飯店相機上傳
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/hotelsearch"
                                        style={location.pathname === '/hotelsearch' ? getActiveButtonStyle(true) : getButtonStyle(true)}
                                        onClick={handleNavClick}
                                    >
                                        多飯店管理者分析看版
                                    </Nav.Link>
                                </div>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>

            {/* Page content */}
            <div style={{ padding: '10px' }}>
                {children}
            </div>
        </Container>
    );
}

export default CustomLayout;
